module.exports = __webpack_public_path__ + "img/aliens-sound.e1a5b705.png";